import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";

export default function CG_FinancingInfo({ setFormData, formData, setCurrentScreen, currentScreen, navigate, screen }) {
    const handleNext = (e) => {
        e.preventDefault();
        if (!formData.price || !formData.contingencies1 || !formData.size1 || !formData.stories1) {
            alert("Please fill out all required fields.");
            return;
        }
        setCurrentScreen(3);
        console.log("Form submitted successfully:", formData);
        // Proceed with further actions, such as navigating or API calls.
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({ ...pre, [name]: value }));
    };
    return (
        <form onSubmit={handleNext} className="tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div className="tw-flex tw-w-full tw-flex-col tw-items-center">
                <h2 className="tw-mt-5 tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Financing Information</h2>
                <div className="tw-w-full xl:tw-w-[70%] tw-flex tw-flex-col tw-items-center tw-gap-2 tw-mt-5">
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Type of financing:</p>
                        <select
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                            name="financing1"
                            value={formData.financing21}
                            onChange={handleInputChange}
                            required
                        >
                            <option value={""}>Select financing</option>
                            <option value={"House"}>House</option>
                            <option value={"Plote"}>Plote</option>
                            <option value={"Agriculture"}>Agriculture</option>
                        </select>
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Type of financing:</p>
                        <select
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                            name="financing2"
                            value={formData.financing2}
                            onChange={handleInputChange}
                            required
                        >
                            <option value={""}>Select financing</option>
                            <option value={"House"}>House</option>
                            <option value={"Plote"}>Plote</option>
                            <option value={"Agriculture"}>Agriculture</option>
                        </select>
                    </div>

                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Down-payment :</p>
                        <input placeholder="Enter your option" required className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" />
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input placeholder="Enter your option" required className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" />
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input placeholder="Enter your option" required className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" />
                    </div>
                </div>
            </div>
            <CG_FooterButtons currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} navigate={navigate} />
        </form>
    );
}
